import { render, staticRenderFns } from "./Vocabulary.vue?vue&type=template&id=5495e9fc&scoped=true&"
import script from "./Vocabulary.vue?vue&type=script&lang=js&"
export * from "./Vocabulary.vue?vue&type=script&lang=js&"
import style0 from "./Vocabulary.vue?vue&type=style&index=0&id=5495e9fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5495e9fc",
  null
  
)

export default component.exports